<template>
  <div  class="product news">
    <div class="header-nav">
      <div class="logo">
        <router-link to="/home">
          <img src="../assets/images/setAimLogo.png" alt="">
        </router-link>
      </div>
      <div class="menu-btn pc_hide" id="menuBtnId" @click="menuShow()">
        <a><i></i></a>
      </div>
      <div class="nav" :class="{'mhide':!menuDataHide}">
        <a class="close-btn" id="menuCloseBtnId" @click="menuHide()"></a>
        <ul>
          <li @click="linkSetAim('top1')">成立宗旨 <em></em> </li>
          <li @click="linkSetAim('top2')">捐款章程 <em></em></li>
          <li @click="linkSetAim('top3')" class="active">最新消息 <em></em></li>
          <li @click="linkSetAim('top4')">辦事細則 <em></em></li>
          <li @click="linkSetAim('top5')">基金會概況表<em></em></li>
          <li @click="linkSetAim('top6')">捐款人名冊<em></em></li>
        </ul>
      </div>
    </div>
    <div class="product-main">
      <div class="product-conten">
        <div class="nav nav-news mobile_hide">
          <h4>分類</h4>
          <ul>
            <li v-for="(item,index) in list" :key="index"  :class="{ active: name == item.type }" class="box">
              <a @click="linkSetAim('top3')">{{item.type}}</a><em class="nav-line"></em></li>
          </ul>
        </div>
        <div class="news-show newsDetails-show" >
          <div class="product-title">
            <router-link to="/setAim" >首頁</router-link>
            <em> /  </em>
            <a @click="linkSetAim('top3')" class="no-line">{{$t("home_3")}}</a>
            <em> /</em>
            <span>{{newList.title}}</span>
          </div>
          <h4>{{newList.title}}</h4>
          <p class="date"><span>發布日期：</span>{{newList.date}}</p>
          <div class="img pc_hide">
            <img :src="newList.image" alt="">
          </div>
          <div class="contenText" v-html="newList.content">
          </div>
          <div class="img mobile_hide">
            <img :src="newList.image" alt="">
          </div>
          <div class="content-page">
            <div class="onPage" v-if="newList.pageup.id">
              <div class="pageBtn">
                <router-link class="gray" :to="'/setAimDetails/'+newList.pageup.id">上一篇</router-link>
                <i></i>
              </div>
              <div  class="text mobile_hide">
                <span class="conten-title ">{{newList.pageup.title}}</span>
                <em class="line"></em>
              </div>
            </div>
            <div class="nextPage" v-if="newList.nextpage.id">
              <div class="text mobile_hide">
                <span class="conten-title">{{newList.nextpage.title}}</span>
              </div>
              <div class="pageBtn">
                <router-link class="gray" :to="'/setAimDetails/'+newList.nextpage.id">下一篇</router-link>
                <i></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="setFoot">
      <div>
        <p>Copyright 2020 © 八方雲集國際股份有限公司 All Rights Reserved </p>
      </div>
    </div>
  </div>
</template>

<script>
  import API from "./config/api";
  export default {
    name: 'SetAimDetails',
    inject:['reload'],
    data () {
      return {
        name:'',
        list:[
          {type:'最新消息'},

        ],
        newList:{},
        mobileActive:0,
        menuDataHide:false
      }
    },
    mounted () {
      console.log(5)
        this.name = this.list[0].type;
        this.GetnewList(this.$route.params.id);
    },
    methods:{
      linkSetAim(id){
        this.$router.push({path: '/setAim', query: {
          id: id
        }});
      },
      menuShow(){
        this.menuDataHide=true;
      },
      menuHide(){
        this.menuDataHide=false;
      },
      GetnewList(id){
        this.$fetch(API.GetWebFoundationNew + id).then((response) => {
            if(response.code === 200){
            this.newList = response.data;
          }
        });

      },
    },
    watch:{
      '$route'(){
        if(this.$route.params.id){
          this.GetnewList(this.$route.params.id)
        }
      }
    }
  }
</script>


<!--<style>
  body{
    padding-top: 0;
  }
  @media (max-width: 1080px) {
    body{
      padding-top: 0;
      background-color:red;
    }
  }
</style>-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  ul{
    padding-left:0;
  }
  .product{
    width: 100%;
    height:auto;
  .top-img{
    width: 100%;
    height: 100%;
  img{
    width: 100%;
    height: 100%;
    background-size: cover;
  }
  }
  .product-main{
    width: 100%;
    height: 100%;
    background: #f9f9f9 ;
    background-size: cover;
    overflow: hidden;
    padding-top: 223px;
    padding-bottom: 180px;
  }
  .product-conten{
    max-width:1410px;
    margin-left: 240px;
  .product-title{
      padding-bottom:40px;
      font-size: 14px;
      letter-spacing: 1.5px;
      text-align: left;
    a{
      color: #000;
      text-decoration: underline;
    }
    .no-line{
      color: #9A928D;
      text-decoration:none;
    }
    em{
      padding: 0 4px;
    }
  span,em{
    color: #9A928D;
  }
  }
    .nav-news{
      padding: 59px 10px 39px 43px;
      h4{
        padding-bottom: 0;
      }
       .active .nav-line{
         right: -25px;
       }
    }

  }
  .product-show{
    width: 1000px;
    height: auto;
    float: left;
    padding-left:100px;
  ul{
    padding-left: 0;
  li{
    width: calc(100% / 3) ;
    padding-right: 4%;
    float: left;
    margin-bottom: 70px;
  div{
    width: 100%;
    height: 280px;
  img{
    width: 100%;
    height: 100%;
    background-size: 100%;
  }
  }
  p{
    text-align: center;
    padding-top: 20px;
  }
  }
  }
  }
  }


  .news-show{
    width:calc(100% - 26%);
    height:100%;
    float: left;
    padding-left:133px;
  ul{
    padding-left:0;
  li{
    width: 100%;
    height: 278px;
    margin-bottom: 24px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 20px;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    fload:left;
  .img{
    width: 340px;
    height: 100%;
    float: left;
  img{
    width: 100%;
    height: 100%;
    background-size: 100%;
  }
  }
  .text{
    width: calc(100% - 340px );
    float: left;
    padding: 37px 37px 22px 62px;
  .latest-news{
    height: 26px;
    line-height: 26px;
    width: 104px;
    background-color: #D00717;
  a{
    color: #fff;
    text-align: center;
    display: block;
    font-size: 14px;
    font-weight: 500;
  }
  }
  .date{
    color: #908782;
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    padding: 18px 0 6px 0;
    span{
      font-style: normal;
    }
  }
  strong{
    font-size: 17px;
  }
  .news-word{
    color: #908782;
    font-size: 16px;
    padding: 6px 0 20px 0;
  }
  }
  .more{
    float:right;
  a{
    color: #D00717;
    font-size: 16px;
  }
  }
  }
  }
  }
  .newsDetails-show{
  .product-title{
    padding-bottom: 10px !important;
  }
  h4{
    font-size: 32px;
    font-weight: 500;
    letter-spacing: 2.67px;
  }
  .date{
    font-size: 18px;
    font-style: italic;
    font-weight: 500;
    padding-top: 18px;
    padding-bottom: 30px;
  }
  .contenText{
    height: auto;
    width:100%;
    letter-spacing: 1px;
    color: #261A16;
    font-size: 18px;
    line-height: 32px;
    text-align: justify;
  p{
    color: #261A16;
    font-size: 18px;
    letter-spacing: 1px;
    line-height: 32px;
    text-align: justify;
  }
  }
  .img{
    width: 100%;
    /*height: 616px;*/
    margin:45px 0;
    img{
      width: 100%;
      height: 100%;
      background-size: 100%;
    }
  }
  }

  @media (max-width:1560px){
    .product .product-conten{
      margin: 0 50px;
    }
  }
  @media (max-width:1080px){
    .news-show{
      width: 100%;
      padding-left: 0;
      float: none;

    }
    .product .product-main{
      padding-top: 95px !important;
    }
    .product .product-conten .product-title{
      padding-bottom: 47px !important;
    }
    .newsDetails-show{
    h4{
      font-size: 18px;
      font-weight: 500;
    }
    .date{
      font-size: 12px;
      color: #908782;
      padding-top: 0px;
      padding-bottom: 40px;
    }
    .img{
  /*    height: 285px;*/
      margin: 0;
    }
    .contenText{
      margin-top:25px;
      font-size: 15px;
      letter-spacing: 0.5px;
      line-height: 28px;
      text-align: justify;

  }
  }
  .content-page{
    margin-top:16px;
    .onPage .text{
      border-right: 0;
    .gray{
      font-size: 14px;
    }

  }
  .nextPage .red{
    font-size: 14px;
  }
  div .conten-title{
    display: none;
  }
  }

    .product .product-conten{
      padding:0;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/setAimDetails.vue